export default __webpack_public_path__ + "static/media/rate_three.74333ee2.png";